import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import CoolenWordGroupResultPopup from "@/pages/comp/coolen/word_group/result/popup/group_result";
import getXcolumnJson from "./xcolumn/list";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import SearchArea from "./area/search";
import StuListArea from "./area/list";

function WordInsideListArea(props: any) {
  let myProps = {
    inside_seq: "",
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  let now_date_str = DateFunc.get_date_format(new Date(), "Y-m-d");
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_stu_name_like: "",
    s_is_success: "",
    order_id: "a_re_start_date DESC, a_stu_name",
  });
  const [inside_info, set_inside_info] = useState<any>({});
  const [infoArr, setInfoArr] = useState<any>([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const default_popup_data = {
    isOpen: false,
    sort: "study_result",//study_result
    g_par_id: "",
    g_par_seq: "",
    stu_seq: "",
    title: "팝업",
    width: "100%",
    height: "90%",
  };
  const [popupData, setPopupData] = useState({ ...default_popup_data });

  useEffect(() => {
    get_word_inside_info_by_ajax({ inside_seq: myProps.inside_seq });
    list({});
  }, [user.comp_seq]);

  const get_word_inside_info_by_ajax = (inData: any) => {
    let opt_obj = {
      inside_seq: "",
      ...inData
    };
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    if (strFunc.is_empty(opt_obj.inside_seq)) {
      alert("단어장 키가 없습니다.");
      myProps.closePopup();
      return false;
    }
    let form_json_data: any = {
      s_seq: opt_obj.inside_seq,
      s_mcomp_seq: user.comp_seq,
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            set_inside_info(response.data["data"]["info_arr"][0]);
          } else {
            alert("해당하는 단어장이 존재하지 않습니다.");
            myProps.closePopup();
          }
        } else {
          alert("단어장 정보를 가져오는 데 실패했습니다.");
          myProps.closePopup();
        }
      });
  };

  const list = (inOptObj: any) => {
    let tmp_listOpt: any = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_listOpt);
    tmp_listOpt.s_mcomp_seq = user.comp_seq;
    tmp_listOpt.s_inside_seq = myProps.inside_seq;
    if (strFunc.is_empty(tmp_listOpt.s_mcomp_seq)) {
      return false;
    }
    if (strFunc.is_empty(tmp_listOpt.s_inside_seq)) {
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside_use/list', tmp_listOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
        } else {

        }
      });
  };

  const open_study_result_popup = (inData: any) => {
    let opt_obj = {
      g_par_id: "word_inside",
      g_par_seq: myProps.inside_seq,
      stu_seq: "",
      ...inData
    };

    if (strFunc.is_empty(opt_obj.g_par_id)) {
      return false;
    }
    if (strFunc.is_empty(opt_obj.g_par_seq)) {
      return false;
    }
    if (strFunc.is_empty(opt_obj.stu_seq)) {
      return false;
    }

    setPopupData({
      ...default_popup_data,
      isOpen: true,
      sort: "study_result",
      title: "학습결과",
      g_par_id: opt_obj.g_par_id,
      g_par_seq: opt_obj.g_par_seq,
      stu_seq: opt_obj.stu_seq,
      width: "80%",
    });
  };

  return (
    <div>
      <div>
        {inside_info.a_title}
      </div>
      <div>
        <SearchArea
          list={list}
          listOpt={listOpt}
          setListOpt={setListOpt}
        ></SearchArea>
      </div>
      <div className='mt-1'>
        <StuListArea
          info_arr={infoArr}
          xColumnArr={xColumnArr}
          open_study_result_popup={open_study_result_popup}
        ></StuListArea>
      </div>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.tot}
        is_view_num_per_page={true}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
        onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>

      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort == "study_result" &&
            <CoolenWordGroupResultPopup
              g_par_id={popupData.g_par_id}
              g_par_seq={popupData.g_par_seq}
              stu_seq={popupData.stu_seq}
              callBackData={(inData: any) => { }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></CoolenWordGroupResultPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default WordInsideListArea;